import queryString from 'query-string'
import apiClient from './api-client'

function createEMREvent(resultId, resultType, eventType) {
  return apiClient.post('v2/ehr/events', {
    result_id: resultId,
    result_type: resultType,
    event_type: eventType,
  })
}

function sendAlertToEMR(alertId) {
  return createEMREvent(alertId, 'Alert', 'alert_generated')
}

function getEvent(resultId, resultType, eventType) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'v2/ehr/events',
      query: {
        result_id: resultId,
        result_type: resultType,
        event_type: eventType,
      },
    }),
  )
}

export default {
  createEMREvent,
  sendAlertToEMR,
  getEvent,
}
